<script>
    import Nav from './Nav.svelte'
</script>

<main>
    <Nav/>
    <div class="container">
        <h1>Welcome to Tino Exchange!</h1>
        <p>This is a service for Tino students to be able to post things they own, such as old prep books, calculators, or any other items they think others could use! Get started by registering your FUHSD email, and browse the list of items available now!</p>
    </div>
</main>